import React from 'react';
import { useScrollReveal } from './useScrollReveal';

const PRINCIPLES = [
  {
    title: 'Practical before pretty',
    copy: 'Every idea has to survive the real world: budget, guest count, setup time, and what a host can actually buy or make.',
  },
  {
    title: 'Guided, not overwhelming',
    copy: 'CraftMyParty keeps the flow simple: describe the event, compare strong theme directions, then turn one into an actionable plan.',
  },
  {
    title: 'You stay in control',
    copy: 'AI helps draft the plan, but hosts can edit colors, swap items, tune budgets, and decide what makes sense for their own event.',
  },
];

export default function AboutSection() {
  const reveal = useScrollReveal();

  return (
    <section id="about" className="py-20 sm:py-28 px-4 sm:px-6 bg-white border-t border-[var(--brand-border)] overflow-hidden w-full max-w-full">
      <div className="max-w-6xl mx-auto w-full">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-10 lg:gap-14 items-start">
          <div className="sr-item" ref={reveal}>
            <p className="text-sm font-semibold uppercase tracking-widest mb-3" style={{ color: 'var(--brand-violet)' }}>
              About CraftMyParty
            </p>
            <h2
              className="font-extrabold leading-tight mb-5"
              style={{ fontSize: 'clamp(1.8rem, 4vw, 2.75rem)', color: 'var(--brand-charcoal)' }}
            >
              Built for real-life hosts, not perfect-party pressure.
            </h2>
            <p className="text-base sm:text-lg leading-relaxed" style={{ color: 'var(--brand-muted)' }}>
              CraftMyParty helps DIY hosts and small teams move from a vague event idea to a realistic plan with themes, sourcing, budget guardrails, and next steps.
            </p>
          </div>

          <div className="sr-stagger grid gap-4" ref={reveal}>
            {PRINCIPLES.map((item) => (
              <div
                key={item.title}
                className="sr-item rounded-2xl bg-[var(--brand-cream)] p-5 sm:p-6 border border-[var(--brand-border)]"
              >
                <h3 className="text-lg font-extrabold mb-2" style={{ color: 'var(--brand-charcoal)' }}>
                  {item.title}
                </h3>
                <p className="text-sm sm:text-base leading-relaxed" style={{ color: 'var(--brand-muted)' }}>
                  {item.copy}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
